import React, { useState, useEffect } from "react";
import styles from "../../styles/Videos/video.module.css";
import "../../styles/Videos/video.css";
const PlayableVideo = ({ thumbnailUrl, title, width, onClick }) => {
  const [isLoading, setIsLoading] = useState(true); // State to manage loading
  const containerStyle = width ? { minWidth: width } : { minWidth: "200px" };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="playableVideoContainer" style={containerStyle} onClick={onClick}>
      {isLoading ? (
        <div className={styles.skeletonContainer}>
          {/* Skeleton Loader */}
          <div className={styles.skeletonImage}></div>
          <div className={styles.skeletonTitle}></div>
        </div>
      ) : (
        <>
          <div className={styles.playableVideoImage}>
            <img
              src={thumbnailUrl}
              alt="thumbnail"
              onLoad={() => setIsLoading(false)} // Ensures loading state ends when the image loads
            />
          </div>
          <div className={styles.playableVideoTitle}>{title}</div>
        </>
      )}
    </div>
  );
};

export default PlayableVideo;